export default __webpack_public_path__ + "static/media/portfolio01.da8b87ad.png";